import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeOut32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFadeOut32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M14.637 30.212a1.2 1.2 0 0 1-.302-.039C7.211 29.38 1.672 23.34 1.672 16.004l.005-.368C1.858 8.483 7.309 2.64 14.292 1.841a1.2 1.2 0 0 1 1.545 1.148v26.023a1.2 1.2 0 0 1-1.2 1.2m4.837-.7a1.2 1.2 0 0 1-1.2-1.2V3.692a1.2 1.2 0 0 1 2.4 0v24.62a1.2 1.2 0 0 1-1.2 1.2m-6.037-25.1c-5.352 1.146-9.365 5.899-9.365 11.592s4.013 10.449 9.365 11.594zm10.862 22.536a1.2 1.2 0 0 1-1.2-1.2V6.25a1.201 1.201 0 0 1 2.4 0v19.498a1.2 1.2 0 0 1-1.2 1.2m4.83-4.352a1.2 1.2 0 0 1-1.2-1.2V10.609a1.201 1.201 0 0 1 2.401 0v10.787a1.2 1.2 0 0 1-1.2 1.2"
            />
        </svg>
    );
}
export default memo(IconFadeOut32);
